import { render, staticRenderFns } from "./MetricsView2.vue?vue&type=template&id=242252ca&scoped=true&"
import script from "./MetricsView2.vue?vue&type=script&lang=js&"
export * from "./MetricsView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242252ca",
  null
  
)

export default component.exports